import { SingleGridResponse, TIUtilities } from "../../../../../pure-javascript-api/ti-js-api";
import { DateHelpers } from "../../helpers/date-helpers";
import { TIChartPointModel } from "../../models/data-point/ti-chart-point.model";

export class JSApiPointToTiChartDataPointMapper {
    public static map(rawData: Map<string, SingleGridResponse>, xValueStartFrom: number, showPreMarket: boolean, showPostMarket: boolean): Array<TIChartPointModel> {
        if (!rawData?.size) {
            return [];
        }

        const result: Array<TIChartPointModel> = [];
        for (const [symbol, response] of rawData) {
            let headers: Array<string> = [];
            let countValidRow = 0;
            for (let i = 0; i < response.grid.length; i++) {
                const dataRow = response.grid[i];
                if (i == 0) {
                    headers = dataRow;
                    continue;
                }

                if (dataRow.length && !!dataRow[0]) {
                    const dataPoint: any = new TIChartPointModel();
                    dataPoint.xValue = xValueStartFrom + countValidRow;
                    dataPoint.symbol = symbol;
                    countValidRow++;
                    
                    for (let j = 0; j < dataRow.length; j++) {
                        const dataCell = dataRow[j];
                        let objKey = headers[j].split(' ').join('').toLowerCase();
                        if (objKey == 'starttime') {
                            continue;
                        } else if (objKey == 'start') {
                            dataPoint.startTimeT = parseFloat(dataCell);
                            dataPoint.start = TIUtilities.decodeServerTime(dataCell);
                            dataPoint.startMarketTimeZone = DateHelpers.toMarketTimeZone(dataPoint.start).toJSDate();
                            dataPoint.timestamp = DateHelpers.getTimeStampWithCurrentTimezone(dataPoint.start);

                            if (showPreMarket) {
                                dataPoint.isPreMarket = DateHelpers.isPremarket(dataPoint.start);
                                // if (dataPoint.isPreMarket)
                                //     TraceLoggingHelpers.log('---------isPreMarket POINT---------', dataPoint)
                            }

                            if (showPostMarket) {
                                dataPoint.isPostMarket = DateHelpers.isPostmarket(dataPoint.start);
                                // if (dataPoint.isPostMarket)
                                //     TraceLoggingHelpers.log('---------isPostMarket POINT---------', dataPoint)
                            }

                        } else if (objKey == 'end') {
                            dataPoint.endTimeT = parseFloat(dataCell);
                            dataPoint.end = TIUtilities.decodeServerTime(dataCell);
                            dataPoint.endMarketTimeZone = DateHelpers.toMarketTimeZone(dataPoint.end).toJSDate();
                        } else {
                            dataPoint[objKey] = parseFloat(dataCell);

                            if (objKey === 'avg_volume') {
                                dataPoint.volumeAvg = dataPoint[objKey];
                            }
                        }
                    }

                    result.push(dataPoint);
                }
            }
        }

        return result;
    }
}